import React, { useEffect, useState, useContext } from "react";
import { getData } from "../../../fetchRoutes/getData";
import SellerChat from "./sellerChat";
import { UserContext } from "../../../context/userContext";
import SellerSidebar from "../../../navigation/sellerNavigation";
import { toast } from 'react-toastify';
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function SellerChatContainer() {

    const getChats = process.env.REACT_APP_GET_CHATS;

    const { userDetails } = useContext(UserContext);
    const {isMobile}= useContext(DeviceContext);
    const [chatRequests, setChatRequests] = useState([]);
    const [activeBuyer, setActiveBuyer] = useState(null);
    const [chatVisible, setChatVisible] = useState(false);
    const [endedChats, setEndedChats] = useState([]);
    const [minimized, setMinimized] = useState(false);


    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const chatsPerPage = isMobile ? 2:8;

    useEffect(() => {
        const fetchChats = async () => {
            try {
                const res = await getData(`${getChats}/${userDetails._id}/chats`);
                if (res.status === "Success") setChatRequests(res.chats);
            } catch (err) {
                console.error("Error loading chat requests:", err);
            }
        };

        fetchChats();
    }, [userDetails, getChats]);

    const handleAccept = (buyerId) => {
        setActiveBuyer(buyerId);
        setChatVisible(true);
        setMinimized(false);
    };

    const closeChat = async () => {
        setEndedChats(prev => [...prev, activeBuyer]);
        toast.success("Chat ended!");
        setChatVisible(false);
        setActiveBuyer(null);

        // Refresh chat list
        try {
            const res = await getData(`${getChats}/${userDetails._id}/chats`);
            if (res.status === "Success") setChatRequests(res.chats);
        } catch (err) {
            console.error("Error reloading chats:", err);
        }
    };

    const handleMinimize = () => {
        setMinimized(true);
        setActiveBuyer(null);



    }

    // Pagination logic
    const indexOfLastChat = currentPage * chatsPerPage;
    const indexOfFirstChat = indexOfLastChat - chatsPerPage;
    const currentChats = chatRequests
        .filter(chat => !endedChats.includes(chat.buyerId))
        .slice(indexOfFirstChat, indexOfLastChat);

    const totalPages = Math.ceil(chatRequests.length / chatsPerPage);

    return (
        <main className="sellerDashboard">
            {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}

            <div className="container noWinContainer">
                <h1 className="containerTitle">CHATS REQUESTS</h1>
                <div className="sellerChatWrapper">
                    {/* Active Chat Requests */}
                    <div className="propertyList">
                        {chatRequests.length === 0 && (
                            <div className="noChatContainer">
                                <h2 className="noChatTitle">No Chats Yet</h2>
                                <p className="noChatText">
                                    Looks like no one has requested a chat yet. Once buyers join, they’ll appear here.
                                </p>
                                <a href="/auctions" className="noChatButton">Browse Live Auctions</a>
                            </div>
                        )}

                        {currentChats.map((chat, index) => (
                            <div className="chatCard" key={chat.buyerId}>
                                {/* User Profile */}
                                <div className="userPicture">
                                    <span
                                        className="chatAvatar"
                                        style={{
                                            backgroundImage: `url(${process.env.REACT_APP_BACKEND}/${chat.image.replace('public/', '')})`
                                        }}
                                    />
                                </div>

                                {/* Chat Details */}
                                <div className="chatDetails">
                                    <div className="detail">
                                        <p className="pTitle">Name:</p>
                                        <p className="userName">{chat.name}</p>
                                    </div>
                                    <div className="detail">
                                        <p className="pTitle">Message:</p>
                                        <p
                                            className="userName chatMessage"
                                            title={chat.latestMessage}
                                        >
                                            {chat.latestMessage.split(' ').slice(0, 5).join(' ') + (chat.latestMessage.split(' ').length > 5 ? '...' : '')}
                                        </p>
                                    </div>


                                    {chat.unreadCount > 0 && (
                                        <div className="detail">
                                            <p className="pTitle">Total:</p>
                                            <p className="userName">{chat.unreadCount} messages</p>
                                        </div>
                                    )}
                                </div>

                                <div className="chatNow">
                                    <button
                                        onClick={() => handleAccept(chat.buyerId)}
                                        className="submitButton"
                                        disabled={activeBuyer === chat.buyerId & index !== 0}
                                    >
                                        {activeBuyer === chat.buyerId ? "Chatting...": "Accept"}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {(chatVisible || minimized) && (
                <>
                    {!minimized && (
                        <div className="chatPopup">
                            <SellerChat
                                sellerId={userDetails._id}
                                buyerId={activeBuyer}
                                onEndChat={() => setActiveBuyer(null)}
                                onClose={closeChat}
                                onMinimize={handleMinimize}
                            />
                        </div>
                    )}
                </>
            )}



            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="pagination">
                    <button
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
                    >
                        Previous
                    </button>

                    <span className="pageInfo">Page {currentPage} of {totalPages}</span>

                    <button
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
                    >
                        Next
                    </button>
                </div>
            )}
        </main>
    );
}
